export const SupplyTypes = {
  ISupplyService: Symbol("ISupplyService"),
};
